<template>
  <div
    class="c-virtual-list__row"
    @click.prevent.stop="click"
    v-bind:class="{ 'is-checked': isChecked }"
  >
    <div class="c-virtual-list__col check">
      <Checkbox
        :id="'check_' + item.index"
        name="keywords[]"
        :value="item"
        :checked="checked"
        ref="checkbox"
        @change="change"
      />
    </div>
    <div class="c-virtual-list__col keyword">
      <div :class="taskCssClass">
        <EllipsisPopover :clamp="2" placement="right-end">
          <p>{{ item.keyword }}</p>
        </EllipsisPopover>
      </div>
    </div>
    <div class="c-virtual-list__col search-volume c-text--right">
      {{ item.searchVolume | separateNumber }}
    </div>
    <div class="c-virtual-list__col rank c-text--right">
      {{ item.competitorSiteRank }}
    </div>
    <div class="c-virtual-list__col rank c-text--right">
      {{ ownSiteRank }}
    </div>
    <div
      class="c-virtual-list__col gap c-text--right"
      :class="{
        textRed: isMinusGap,
        'c-text--bold': item.rankGap && !gscError
      }"
    >
      {{ rankGap }}
    </div>
    <div class="c-virtual-list__col c-text--clamp url">
      <EllipsisPopover :clamp="2" placement="right-end">
        <a
          :href="item.competitorSitePageUrl"
          target="_blank"
          class="c-link--blank"
          @click.stop
        >
          {{ item.competitorSitePageUrl }}
        </a>
        <template slot="popover">
          <a :href="item.competitorSitePageUrl" target="_blank" @click.stop>
            {{ item.competitorSitePageUrl }}
          </a>
        </template>
      </EllipsisPopover>
    </div>
    <div class="c-virtual-list__col c-text--clamp url">
      <template v-if="item.ownSiteUrl">
        <EllipsisPopover :clamp="2" placement="right-end">
          <a
            :href="item.ownSiteUrl"
            target="_blank"
            class="c-link--blank"
            @click.stop
          >
            {{ removedOwnSiteUrl }}
          </a>
          <template slot="popover">
            <a :href="item.ownSiteUrl" target="_blank" @click.stop>
              {{ removedOwnSiteUrl }}
            </a>
          </template>
        </EllipsisPopover>
      </template>
      <template v-else>
        -
      </template>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox';
import EllipsisPopover from '@/components/EllipsisPopover';

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    checked: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    gscError: {
      type: Boolean,
      required: false
    }
  },
  components: {
    Checkbox,
    EllipsisPopover
  },
  computed: {
    isChecked() {
      return this.checked.some(check => check.id === this.item.id);
    },
    isMinusGap() {
      if (this.item.rankGap == null || this.gscError) {
        return false;
      }
      return this.item.rankGap < 0;
    },
    ownSiteRank() {
      if (this.gscError) {
        return '-';
      }
      if (!this.item.ownSiteRank) {
        return '取得中';
      }
      if (this.item.ownSiteRank == 9999) {
        return '圏外';
      }
      return this.item.ownSiteRank;
    },
    rankGap() {
      if (this.gscError) {
        return '-';
      }
      // 自社順位がnullの場合は取得中
      if (!this.item.ownSiteRank) {
        return '取得中';
      }
      // 自社サイトの順位が圏外の時、GAPは競合順位マイナス9999で計算。
      // 画面上では表示せず、ソートの時に使う。
      if (this.item.ownSiteRank == 9999) {
        return '-';
      }
      return this.item.rankGap;
    },
    removedOwnSiteUrl() {
      if (!this.item.ownSiteUrl) {
        return null;
      }
      return this.$options.filters.removeDomain(
        this.item.ownSiteUrl,
        this.project.siteUrl
      );
    },
    taskCssClass() {
      if (this.item.hasTask) {
        return 'hasTask';
      } else if (this.item.completedTask) {
        return 'completedTask';
      } else {
        return '';
      }
    }
  },
  methods: {
    change(checked) {
      this.$emit('check', checked);
    },
    click() {
      this.$refs.checkbox.change();
    }
  }
};
</script>
